import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, Loader2, Link2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { getToken } from '../services/tokenService';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Super admin / COOPER'S : envoie au membre un lien SMS (48 h) pour qu'il signe lui-même FTPE + dispositif.
export const EnvoyerLienSignatureMembre = ({ souscriptionId, avenantId, telephone, ftpeAdhesionId, className = '' }) => {
  const { user } = useAuth();
  const [tel, setTel] = useState(telephone || '');
  const [loading, setLoading] = useState(false);
  const [envoye, setEnvoye] = useState(null);
  if ((!souscriptionId && !avenantId) || !['super_admin', 'admin', 'cooper'].includes(String(user?.role || '').toLowerCase())) return null;
  const endpoint = avenantId ? `avenants/${avenantId}` : `souscriptions/${souscriptionId}`;

  const envoyer = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/${endpoint}/lien-signature-membre`,
        { telephone: tel, origin: window.location.origin, ftpe_adhesion_id: ftpeAdhesionId || undefined },
        { headers: { Authorization: `Bearer ${getToken()}` } });
      setEnvoye(data.telephone_masque);
      toast.success(`Lien de signature envoyé par SMS au ${data.telephone_masque} (valable ${data.expires_in_hours} h)`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Envoi du lien impossible");
    } finally { setLoading(false); }
  };

  return (
    <div className={`rounded-xl border-2 border-dashed border-indigo-200 bg-indigo-50/90 p-5 space-y-3 text-left ${className}`} data-testid="lien-signature-membre">
      <p className="flex items-center gap-2 text-sm font-semibold text-indigo-900"><Link2 className="h-4 w-4" /> Faire signer le membre lui-même</p>
      <p className="text-xs text-indigo-700">Le membre reçoit un lien par SMS, valable 48 h, pour signer lui-même : {avenantId ? "l'avenant" : "la FTPE (s'il n'est pas déjà adhérent à jour) puis le dispositif"}.</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <Input value={tel} onChange={(e) => setTel(e.target.value)} placeholder="Téléphone du membre" className="h-11" data-testid="lien-signature-membre-tel" />
        <Button onClick={envoyer} disabled={loading || !tel} className="h-11 bg-indigo-600 hover:bg-indigo-700 gap-2" data-testid="lien-signature-membre-envoyer">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Envoyer le lien de signature au membre
        </Button>
      </div>
      {envoye && <p className="text-xs text-emerald-700" data-testid="lien-signature-membre-confirmation">Lien envoyé au {envoye}. Il est désactivé dès qu'un nouveau lien est envoyé.</p>}
    </div>
  );
};
